<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <Sidebar></Sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>
              <a-breadcrumb>
                <a-breadcrumb-item>Subscription cancelation reasons</a-breadcrumb-item>
              </a-breadcrumb>
            </h2>
          </a-col>
        </a-row>
        <CancelReasons />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import CancelReasons from '@/components/Subscriptions/CancelReasons.vue';

export default {
  components: {
    Sidebar,
    CancelReasons
  }
};
</script>
